import { locations } from "@/mocks/site-data";

export default function LocationsSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-50 text-secondary-800 text-xs font-semibold tracking-wide uppercase mb-4">
            Onde Estamos
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-4">
            Nossas Unidades
          </h2>
          <div className="w-16 h-1 bg-accent-500 mx-auto rounded-full mb-5" />
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            Presentes em 4 estados do Brasil, sempre próximos dos nossos clientes.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 max-w-6xl mx-auto">
          {locations.map((loc) => (
            <div
              key={loc.id}
              className="bg-background-50 border border-background-200 rounded-xl p-6 hover:border-primary-200 transition-all"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-50 border border-primary-200 flex items-center justify-center mb-4">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line text-primary-600" />
                </div>
              </div>
              <h3 className="text-base font-bold text-foreground-900 font-heading mb-1">
                {loc.city} - {loc.state}
              </h3>
              {loc.name && (
                <p className="text-xs text-accent-600 font-medium mb-2">
                  {loc.name}
                </p>
              )}
              <p className="text-xs text-foreground-600 leading-relaxed mb-1">
                {loc.addressLine1}
              </p>
              {loc.addressLine2 && (
                <p className="text-xs text-foreground-600 leading-relaxed mb-1">
                  {loc.addressLine2}
                </p>
              )}
              {loc.neighborhood && (
                <p className="text-xs text-foreground-600 leading-relaxed mb-1">
                  {loc.neighborhood}
                </p>
              )}
              <p className="text-xs text-foreground-400 mb-2">
                {loc.cep}
              </p>
              <p className="text-xs font-semibold text-primary-600">
                <i className="ri-phone-line mr-1" />
                {loc.phone}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}